import {HttpClient}     from '@angular/common/http';
import {Injectable}     from '@angular/core';
import {StorageService} from '@src/app/core/services/storage.service';
import {BaseService}    from '@src/app/shared/services/base.service';
import {map, Observable} from 'rxjs';
import {AssigneeUser, User} from '../models/user.model';
import {query}          from 'js-query-builder';

@Injectable({
    providedIn: 'root'
})
export class UsersService extends BaseService
{
    constructor(
        public storageService: StorageService,
        private http: HttpClient
    )
    {
        super();
    }

    get user(): User
    {
        return JSON.parse(this.storageService.read('user')) ?? null;
    }

    /*
     * @Deprecated - USe AuthService for the currently authenticated user
     */
    set user(user: User)
    {
        this.storageService.write('user', JSON.stringify(user));
    }

    public list(pageNumber: number, pageSize: number = 50, array = null): Observable<any>
    {
        const url: string = array
            ? `${this.apiUrl}/users?array`
            : `${this.apiUrl}/users?page[number]=${pageNumber}&page[size]=${pageSize}`;

        return this.http.get(url).pipe();
    }

    public listAssignees(pageSize: number = 1000): Observable<AssigneeUser[]>
    {
        const url = query('users')
            .fields({users: ['id', 'name', 'type_id', 'email']})
            .param('page[number]', '1')
            .param('page[size]', String(pageSize))
            .build();

        return this.http.get(`${this.apiUrl}/${url}`).pipe(
            map((response: any) => response?.data ?? response ?? [])
        );
    }

    /**
     * Cross-tenant user search, restricted to developer accounts on the API.
     * Uses the Spatie QueryBuilder-compatible filter[search] parameter.
     */
    public listCrossTenant(searchTerm: string = ''): Observable<any>
    {
        const url = query('users')
            .fields({users: ['id', 'name', 'email']})
            .when(searchTerm.trim().length > 0, q => q.filter('search', searchTerm.trim()))
            .param('cross_tenant', '1')
            .param('page[size]', '250')
            .build();

        return this.http.get(`${this.apiUrl}/${url}`).pipe();
    }

    public invite(data): Observable<any>
    {
        return this.http.post(`${this.apiUrl}/users/invite`, data).pipe();
    }

    public get(id): Observable<any>
    {
        return this.http.get(`${this.apiUrl}/users/${id}`).pipe();
    }

    public update(data, id): Observable<any>
    {
        return this.http.put(`${this.apiUrl}/users/${id}`, data).pipe();
    }

    public delete(id): Observable<any>
    {
        return this.http.delete(`${this.apiUrl}/users/${id}`).pipe();
    }

    public resendUserInvite(data): Observable<any>
    {
        return this.http.post(`${this.apiUrl}/users/invite/resend`, data).pipe();
    }

    public ErrorHandler(response): void
    {
        console.error(response);
    }
}
